<template>
  <div >

      <div class="container">



  <div class="view jarallax">
    <img class="jarallax-img" src="/assets/Fondo.png" alt="">
  </div>
            


            <!--Section: Cards-->
            <section class="pt-5">

                <!-- Heading & Description -->
                <div class="wow fadeIn">
                    <!--Section heading-->
                    <h2 class="h1 text-center mb-5">Personal Signer - iOS </h2>
                    <h2 class="h1 text-center mb-5">Import Certificate </h2>
                    <!--Section description-->
                    <p class="text-center"><strong>You need to load your certificate(s) into Personal Signer to start signing documents. For loading a certificate into Personal Signer you have the  options explained below.</strong></p>
                     <p class="text-center"><strong>It is not possible to share a PFX or P12 file diretly from another app in you phone, you will need to create a zip file with the certificate inside or share the ccertificate from an  external URL  .</strong></p>
                    <p class="text-center mb-5 pb-5"><strong>In case you need additional help, please use the contact form in this page and we will contact you to guide you in the process.</strong>
                        </p>
                </div>
                <!-- Heading & Description -->

                <!--Grid row-->
                <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/nD9hgeSHtiI?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Use a zip file containing a certificate</strong>
                        </h3>
                        <p class="blue-text">
                            <ul>
                                <li>Put a PFX or P12 file inside a ZIP file.</li>
                                <li>Send the ZIP file to you cell phone ( eMail, AirDrop,...) and share it with Personal Signer</li>
                                <li>The Import Certificate page will open and you will be asked to  provide the PFX password  </li>
                                </ul>
                             
                            </p>
                        <p>
                            <strong>Easy</strong>
                        </p>
              <!--          <a href="https://youtu.be/i1SxtxDbEfY" target="_blank" class="btn btn-primary btn-md">Start tutorial
                            <i class="fas fa-play ml-2"></i>
                        </a>-->
                    </div>
                    <!--Grid column-->

                </div>
                <!--Grid row-->

                <hr class="mb-5">


                <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1-half">
                            <div class="view overlay">
                                <div class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/Nuo9N0sqO1Y?rel=0" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Download certificate from URL</strong>
                        </h3>
                        <p class="blue-text">
                            <ul>
                                <li>Copy  your PFX or P12 file to a cloud service (Dropbox, Google Drive,...).</li>
                                <li>Obtain the download URL for your file</li>
                                <li>Open "My Certificates" page , click on the Add button (plus sign)   and select  the "Use URL" option </li>
                                <li>You will be asked to provide your certificate password </li>
                                </ul>
                             
                            </p>
                        <p>
                            <strong>Easy</strong>
                        </p>
                    </div>
                    <!--Grid column-->

                </div>
                <hr class="mb-5">



                <!--Grid row-->
                <div class="row mt-3 wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1">
                            <img src="https://mdbootstrap.com/wp-content/uploads/2017/11/brandflow-tutorial-fb.jpg" class="img-fluid" alt="">
                            <a href="https://mdbootstrap.com/education/tech-marketing/automated-app-introduction/" target="_blank">
                                <div class="mask rgba-white-slight"></div>
                            </a>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Bootstrap Automation</strong>
                        </h3>
                        <p class="grey-text">Learn how to create a smart website which learns your user and reacts properly to his behavior.</p>
                        <a href="https://mdbootstrap.com/education/tech-marketing/automated-app-introduction/" target="_blank" class="btn btn-primary btn-md">Start tutorial
                            <i class="fas fa-play ml-2"></i>
                        </a>
                    </div>
                    <!--Grid column-->

                </div>
                <!--Grid row-->

                <hr class="mb-5">

                <!--Grid row-->
                <div class="row wow fadeIn">

                    <!--Grid column-->
                    <div class="col-lg-5 col-xl-4 mb-4">
                        <!--Featured image-->
                        <div class="view overlay rounded z-depth-1">
                            <img src="https://mdbootstrap.com/wp-content/uploads/2018/01/push-fb.jpg" class="img-fluid" alt="">
                            <a href="https://mdbootstrap.com/education/tech-marketing/web-push-introduction/" target="_blank">
                                <div class="mask rgba-white-slight"></div>
                            </a>
                        </div>
                    </div>
                    <!--Grid column-->

                    <!--Grid column-->
                    <div class="col-lg-7 col-xl-7 ml-xl-4 mb-4">
                        <h3 class="mb-3 font-weight-bold dark-grey-text">
                            <strong>Web Push notifications</strong>
                        </h3>
                        <p class="grey-text">Push messaging provides a simple and effective way to re-engage with your users and in this tutorial
                            you'll learn how to add push notifications to your web app</p>
                        <a href="https://mdbootstrap.com/education/tech-marketing/web-push-introduction/" target="_blank" class="btn btn-primary btn-md">Start tutorial
                            <i class="fas fa-play ml-2"></i>
                        </a>
                    </div>
                    <!--Grid column-->

                </div>
                <!--Grid row-->

                <hr class="mb-5">

                <!--Pagination-->
                <nav class="d-flex justify-content-center wow fadeIn">
                    <ul class="pagination pg-blue">

                        <!--Arrow left-->
                        <li class="page-item disabled">
                            <a class="page-link" href="#" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Previous</span>
                            </a>
                        </li>

                        <li class="page-item active">
                            <a class="page-link" href="#">1
                                <span class="sr-only">(current)</span>
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">2</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">3</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">4</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link" href="#">5</a>
                        </li>

                        <li class="page-item">
                            <a class="page-link" href="#" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span class="sr-only">Next</span>
                            </a>
                        </li>
                    </ul>
                </nav>
                <!--Pagination-->

            </section>
            <!--Section: Cards-->

        </div> 
 
  </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to zzzzzzxxxxxz MDB Vue.js App'
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: normal;
  padding-top: 20px;
  padding-bottom: 30px;
}
p {
  color: #969696;
  margin-bottom: 0;
  font-size: 14px;
}
</style>
